module.exports = "../img/wezimed-26fXlnK.svg";